import { Component, OnInit } from '@angular/core';
import {Router} from '@angular/router';
import { ConnectionService } from 'ng-connection-service';

@Component({
  selector: 'app-no-internet',
  templateUrl: './no-internet.component.html',
  styleUrls: ['./no-internet.component.scss']
})
export class NoInternetComponent implements OnInit {

  constructor(private router: Router, private connectionService: ConnectionService) { }

  ngOnInit() {
    this.connectionService.monitor().subscribe(isConnected => {
      if (isConnected) {
        if (typeof history.state.data !== 'undefined') {
          location.href = history.state.data.redirectUrl;
        } else {
          this.router.navigate(['/']);
        }
      }
    });

  }

}
